const contactInitValues = {
  contactName: "",
  contactEmail: "",
  contactPhone: "",
  contactSubject: "",
  contactMessage: "",
};
export default contactInitValues;
